const initializedSections = new WeakSet();

const setItemState = (item, isOpen) => {
  const trigger = item.querySelector('.faq-sec__trigger');
  const panel = item.querySelector('.faq-sec__panel');

  if (!trigger || !panel) {
    return;
  }

  item.classList.toggle('is-open', isOpen);
  trigger.setAttribute('aria-expanded', String(isOpen));
  panel.setAttribute('aria-hidden', String(!isOpen));
};

const initFaqSection = (scope = document) => {
  const sections = scope.matches?.('.faq-sec') ? [scope] : scope.querySelectorAll('.faq-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const items = Array.from(section.querySelectorAll('.faq-sec__item'));

    if (!items.length) {
      return;
    }

    initializedSections.add(section);

    items.forEach((item, index) => {
      setItemState(item, item.classList.contains('is-open') && index === 0);
    });

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('.faq-sec__trigger');

      if (!trigger || !section.contains(trigger)) {
        return;
      }

      const item = trigger.closest('.faq-sec__item');

      if (!item) {
        return;
      }

      const shouldOpen = !item.classList.contains('is-open');

      items.forEach((currentItem) => {
        setItemState(currentItem, currentItem === item && shouldOpen);
      });
    });
  });
};

initFaqSection();
window.initFaqSection = initFaqSection;
